import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import AccountTreeIcon from '@mui/icons-material/AccountTree';
import RouterIcon from '@mui/icons-material/Router';
import SensorsIcon from '@mui/icons-material/Sensors';
import PeopleIcon from '@mui/icons-material/People';
import TokenIcon from '@mui/icons-material/Token';

export enum AdminMode {
    Structure = 'structure',
    Devices = 'devices',
    Sensors = 'sensors',
    Users = 'users',
    Tokens = 'tokens',
}

const modes: { value: AdminMode; label: string; icon: React.ReactNode }[] = [
    { value: AdminMode.Structure, label: 'Структура', icon: <AccountTreeIcon fontSize="small" /> },
    { value: AdminMode.Devices, label: 'Устройства', icon: <RouterIcon fontSize="small" /> },
    { value: AdminMode.Sensors, label: 'Датчики', icon: <SensorsIcon fontSize="small" /> },
    { value: AdminMode.Users, label: 'Пользователи', icon: <PeopleIcon fontSize="small" /> },
    { value: AdminMode.Tokens, label: 'Токены', icon: <TokenIcon fontSize="small" /> },
];

interface Props {
    value: AdminMode;
    onChange: (mode: AdminMode) => void;
}

export default function AdminModeSwitcher({ value, onChange }: Props) {
    return (
        <ToggleButtonGroup
            value={value}
            exclusive
            onChange={(_, next) => next && onChange(next)}
            size="small"
            sx={{ bgcolor: 'background.paper' }}
        >
            {modes.map((m) => (
                <ToggleButton key={m.value} value={m.value} sx={{ gap: 0.75, px: 2, textTransform: 'none' }}>
                    {m.icon}
                    {m.label}
                </ToggleButton>
            ))}
        </ToggleButtonGroup>
    );
}
